import React from 'react';
import ReactDOM from 'react-dom';

/*******************************
 *          LIBRARIES          *
 *******************************/
// CSS
import 'bootstrap/dist/css/bootstrap.css';
import "./lib/font.googleapis.com.Roboto.swap.css"
import "./lib/fontawesome-free-5.11.2-web/css/all.min.css"
// JS
import 'bootstrap/dist/js/bootstrap.js';

import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
